module.exports = __webpack_public_path__ + "lp/img/zoom_in_light.2e2aa319.svg";